import { createSelector } from 'reselect'

import { Breadcrumb } from '@/components/shared/breadcrumbs'
import { CATEGORY_IDS, CATEGORY_NAMES, CATEGORY_WEBPATHS } from '@/constants'
import type { CmsSubCategory } from '@/types/app-types'

import type { SubCategoryState } from './types'

export const subCategorySelector = createSelector(
    (state: SubCategoryState) => state.data,
    (subCategory: CmsSubCategory | undefined): CmsSubCategory | undefined => subCategory,
)

export const breadcrumbsSelector = createSelector(
    (state: SubCategoryState) => state.data?.categoryId,
    (categoryId?: CATEGORY_IDS): Breadcrumb[] => {
        if (categoryId) {
            return [
                {
                    url: CATEGORY_WEBPATHS[categoryId],
                    title: CATEGORY_NAMES[categoryId],
                    isExternal: false,
                },
            ]
        } else {
            return []
        }
    },
)
